function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultTimeout = 500;
var rejectOnTimeout = timeout => new Promise((resolve, reject) => {
  setTimeout(() => reject(new Error('Timeout')), timeout);
});
export default (url, _ref) => {
  var body = _ref.body,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'POST' : _ref$method,
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? defaultTimeout : _ref$timeout,
    forceFetch = _ref.forceFetch,
    debug = _ref.debug;
  // sendBeacon only supports POST
  if (!forceFetch && method === 'POST' && navigator && navigator.sendBeacon) {
    if (debug) {
      console.log('sendBeacon: Calling navigator.sendBeacon');
    }
    navigator.sendBeacon(url, body && JSON.stringify(body));
    if (debug) {
      console.log('sendBeacon: After sendBeacon');
    }
  } else {
    if (debug) {
      console.log('sendBeacon: Calling fetch');
    }
    Promise.race([rejectOnTimeout(timeout), fetch(url, _objectSpread({
      method
    }, body && {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      }
    }))]).catch(error => {
      if (debug) {
        console.error('sendBeacon: Caught error', error);
      }
    }).then(() => {
      if (debug) {
        console.log('sendBeacon: Fetch returned');
      }
    });
  }
};